export default "__VITE_ASSET__CJRqLAlV__"